import { __assign } from 'tslib';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import cn from 'classnames';
import { u as useOverrides, s as styles } from './use-overrides-70538eaf.js';
import { strikethroughRemarkPlugin } from './remark-plugins/strikethrough.js';
import '../../link/esm';
import '../../list/esm';
import '../../typography/esm';
import 'mdast-util-gfm-strikethrough';
import 'micromark-extension-gfm-strikethrough';

var Markdown = function (_a) {
    var children = _a.children, className = _a.className, platform = _a.platform, _b = _a.font, font = _b === void 0 ? 'system' : _b, overrides = _a.overrides;
    var defaultOverrides = useOverrides(platform, font);
    return (React.createElement(ReactMarkdown, { remarkPlugins: [strikethroughRemarkPlugin], components: __assign(__assign({}, defaultOverrides), overrides), className: cn(styles.component, className) }, children));
};

export { Markdown };
